import { environment } from './environment.default';

environment.channelName = 'Dev';
environment.branch = 'dev';
environment.production = false;

export { environment };
